exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1ZyW4jlr3tkbrnUhfyYpVB{word-break:break-all}", ""]);

// exports
exports.locals = {
	"sidecarName": "_1ZyW4jlr3tkbrnUhfyYpVB"
};